import React from "react"
import { Table, TableBody, TableRow, TableRowColumn, FloatingActionButton, CircularProgress } from "material-ui"
import ToolTip from "react-portal-tooltip"
import ContentAdd from "material-ui/svg-icons/content/add"
import { EScheduledJobType, IScheduledJob } from "../../../../models/data/account/settings/IScheduledJob"
import { IScriptLog } from "../../../../models/data/account/settings/IScriptLog"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
import AddScheduleJobDialog from "./AddScheduleJobDialog"
import AccountStore from "../../../../stores/AccountStore"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import moment from "moment"
import { green500, red500, blue500 } from "material-ui/styles/colors"
import { IFAMAccountDTO } from "../../../../models/data/account_manager/FAMAccountDTO"
import he from "he"
import AuthenticationStore from "../../../../stores/AuthenticationStore"

interface IProps {
    isAccountManager?: boolean
    accountManagerId?: string
}
interface IState {
    loading: boolean,
    expand: boolean
    payrollExportScheduledJob: IScheduledJob
    openAddScheduledJobDialog: boolean
    selectedScheduledJob: IScheduledJob
    openLogTooltip: boolean
    openDiffTooltip: boolean
    compileErrors: boolean
    compileErrorsText: string
    loadingScriptLog: boolean
    scriptLog: IScriptLog
    showDiffTooltip: boolean
    showLogTooltip: boolean

    title: string
    selectedClientAccount: IFAMAccountDTO
    actionType: string
    loadingSpinner: boolean
    jobType: string
    openAccountSelectionDialogForFilter: boolean
    selectedClientAccountForFilter: IFAMAccountDTO
}

export default class PayrollExportScheduledJob extends React.Component<IProps, IState> {
    private refreshTimer
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            expand: false,
            showDiffTooltip: false,
            showLogTooltip: false,
            payrollExportScheduledJob: null,
            openAddScheduledJobDialog: false,
            selectedScheduledJob: null,
            openLogTooltip: false,
            openDiffTooltip: false,
            compileErrors: false,
            compileErrorsText: "",
            loadingScriptLog: false,
            scriptLog: null,
            title: "",
            selectedClientAccount: null,
            actionType: "",
            loadingSpinner: false,
            jobType: strings.All_Client_Scheduled_Jobs,
            openAccountSelectionDialogForFilter: false,
            selectedClientAccountForFilter: null,
        }
    }

    componentDidMount() {
        this.getPayrollExportScheduledJob()
        this.refreshTimer = setInterval(() => {
            !this.state.loading && !this.state.loadingSpinner && this.getPayrollExportScheduledJob(false)
        }, 5000)
    }

    componentWillUnmount() {
        this.refreshTimer &&
            clearInterval(this.refreshTimer)
    }

    getJobTypeFilterValue(selectedFilter: string) {
        let filterValue = null
        if (selectedFilter === strings.Client_Accessible_Scheduled_Jobs) filterValue = true
        else if (selectedFilter === strings.Non_Client_Accessible_Scheduled_Jobs) filterValue = false
        return filterValue
    }

    getPayrollExportScheduledJob(showSpinner = true) {
        this.setState({
            loading: true,
            loadingSpinner: showSpinner
        })
        api.getPayrollExportScheduledJob(AccountStore.getCurrentAccount().Id)
            .then(res => {
                if (showSpinner) this.setState({ payrollExportScheduledJob: res.data, loading: false, loadingSpinner: false })
                else this.setState({ payrollExportScheduledJob: res.data, loading: false })
            })

    }

    update(scheduledJob: IScheduledJob) {
        api.updateScheduledJob(scheduledJob.AccountId, scheduledJob)
            .then(res => {
                this.setState({
                    payrollExportScheduledJob: res.data,
                    loading: false,
                    openAddScheduledJobDialog: false,
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_updated)
            })
    }

    add(scheduledJob: IScheduledJob) {
        api.addScheduledJob(AccountStore.getCurrentAccount().Id, scheduledJob)
            .then((res) => {
                this.setState({
                    payrollExportScheduledJob: res.data,
                    loading: false,
                    openAddScheduledJobDialog: false,
                })
                AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
            })
    }

    loadScriptLog(rowIndex, scheduledJob) {
        this.showLogTooltip(rowIndex)

        api.getLatestScriptLog(AccountStore.getCurrentAccount().Id, scheduledJob.Id)
            .then((res) => {
                this.setState({
                    scriptLog: res.data,
                    loadingScriptLog: false,
                })
            })
    }

    runScript(scheduledJob) {
        api.runPayrollExportScript(AccountStore.getCurrentAccount().Id, scheduledJob.Id)
    }

    delete(scheduledJob) {
        api.deleteScheduledJob(AccountStore.getCurrentAccount().Id, scheduledJob.Id)
            .then(() => {
                this.getPayrollExportScheduledJob()
            })
    }

    showDiffTooltip(show) {
        this.setState({ showDiffTooltip: show })
    }

    showLogTooltip(show) {
        this.setState({ showLogTooltip: show })
    }

    render() {
        const isGlobalAdmin = permissionHelper.isGlobalAdmin() ||
            (AuthenticationStore.getLoggedInAccountManagerUser() && permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.AccountScheduledJob))
        return (
            <div>
                <FloatingActionButton
                    data-intercom-target={"menu-AccountSettings-Payroll_Export_Scheduled_Job-Btn-Add"}
                    style={{
                        position: "absolute",
                        marginTop: -93,
                        right: 42,
                        display: "inline-block",
                        zIndex: 100
                    }}
                    mini
                    secondary
                    onTouchTap={() => {
                        this.setState({ openAddScheduledJobDialog: true })
                    }}
                >
                    <ContentAdd />
                </FloatingActionButton>
                {this.state.loadingSpinner ?
                    <div className="spinner"><CircularProgress /></div> :
                    !this.state.payrollExportScheduledJob ?
                        strings.No_payroll_export_scheduled_job :
                        <Table
                            multiSelectable={false}
                            selectable={false}
                            fixedHeader={true}
                            style={{ backgroundColor: "none", borderBottom: "1px solid rgb(224,224,224)", borderTop: "1px solid rgb(224,224,224)" }}
                        >
                            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
                                <TableRow style={{ heigth: 45 }}>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Name}
                                    </TableRowColumn>
                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                        <TableRowColumn style={{ textAlign: "center", paddingLeft: 0, width: 50 }}>
                                            {strings.DiffWithPrevious}
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.Modified_Date}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.LastRunTime}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {strings.NextRunTime}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 160 }}>
                                        {strings.Status}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "right", paddingLeft: 0 }}>
                                        {strings.Action}
                                    </TableRowColumn>
                                </TableRow>
                                <TableRow style={{ heigth: 45 }}>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0 }}>
                                        {this.state.payrollExportScheduledJob.Name}{this.state.payrollExportScheduledJob.Enabled ? "" : " - (disabled)"}
                                    </TableRowColumn>
                                    {(isGlobalAdmin || this.props.isAccountManager) &&
                                        <TableRowColumn
                                            style={{ textAlign: "center", paddingLeft: 0 }}
                                        >
                                            {this.state.payrollExportScheduledJob.CurrentScript.DiffWithPreviousHtml &&
                                                <div>
                                                    <i className="fa fa-exchange" style={{ fontSize: 20, cursor: "pointer", color: blue500 }}
                                                        id={"exchange-"}
                                                        onMouseEnter={() => this.showDiffTooltip(true)}
                                                        onMouseLeave={() => this.showDiffTooltip(false)}
                                                    />
                                                    <ToolTip
                                                        active={this.state.showDiffTooltip}
                                                        position="top"
                                                        arrow="left"
                                                        parent={"#exchange-"}
                                                        key={"#exchange-"}
                                                        group={"#exchange-"}
                                                    >
                                                        <div style={{ padding: 5, width: 1000 }}>
                                                            <div style={{ padding: 5, paddingLeft: 15, overflowY: "auto", maxHeight: 550, width: 990 }} dangerouslySetInnerHTML={{ __html: he.decode(this.state.payrollExportScheduledJob.CurrentScript.DiffWithPreviousHtml) }} />
                                                        </div>
                                                    </ToolTip>
                                                </div>
                                            }
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                        {this.state.payrollExportScheduledJob.CurrentScript.ObjectAudit ? moment(this.state.payrollExportScheduledJob.CurrentScript.ObjectAudit.LastModified).format("MM/DD/YYYY hh:mma") : ""}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                        {this.state.payrollExportScheduledJob.LastRunTime ? moment(this.state.payrollExportScheduledJob.LastRunTime).format("MM/DD/YYYY hh:mma") : ""}
                                    </TableRowColumn>
                                    <TableRowColumn style={{ textAlign: "left", paddingLeft: 0, width: 75 }}>
                                        {this.state.payrollExportScheduledJob.NextRunTime ? moment(this.state.payrollExportScheduledJob.NextRunTime).format("MM/DD/YYYY hh:mma") : ""}
                                    </TableRowColumn>
                                    <TableRowColumn
                                        id={"status-"}
                                        style={{ textAlign: "left", paddingLeft: 0, width: 160, cursor: "pointer" }}
                                        onMouseEnter={() => this.showLogTooltip(true)}
                                        onMouseLeave={() => this.showLogTooltip(false)}
                                    >
                                        {this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.length > 0 &&
                                            <div>
                                                {this.state.payrollExportScheduledJob.InProcess &&
                                                    <i className="fa fa-cog fa-spin" style={{ fontSize: 15 }} />
                                                }
                                                {this.state.payrollExportScheduledJob.InProcess &&
                                                    <span> {strings.Running} {this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].MostRecentLog}</span>
                                                }
                                                {(!this.state.payrollExportScheduledJob.InProcess && this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                    <i className="fa fa-check" style={{ fontSize: 15, color: green500, fontWeight: "bold" }} />
                                                }
                                                {(!this.state.payrollExportScheduledJob.InProcess && this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                    <span style={{ fontSize: 15, color: green500 }}> {strings.Finished}</span>
                                                }
                                                {(!this.state.payrollExportScheduledJob.InProcess && !this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                    <i className="fa fa-exclamation-triangle" style={{ fontSize: 15, color: red500, fontWeight: "bold" }} />
                                                }
                                                {(!this.state.payrollExportScheduledJob.InProcess && !this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].FinishedSuccessfully) &&
                                                    <span style={{ fontSize: 15, color: red500 }}> {strings.Error}</span>
                                                }
                                                <ToolTip
                                                    active={this.state.showLogTooltip}
                                                    position="top"
                                                    arrow="right"
                                                    parent={"#status-"}
                                                    key={"#status-"}
                                                    group={"#status-"}

                                                >
                                                    {this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].LogText &&
                                                        <div style={{ padding: 5, width: 500 }}>
                                                            <div>
                                                                <div><b>Start Time: </b>{moment(this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunStartTime).format("MM/DD/YYYY hh:mm:ssa")}</div>
                                                                <div>
                                                                    <b>End Time: </b>
                                                                    {this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunEndTime != null
                                                                        ? moment(this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].ScriptRunEndTime).format("MM/DD/YYYY hh:mm:ssa")
                                                                        : ""}
                                                                </div>
                                                                <div><b>Duration in Minutes: </b>{this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].MinutesToFinish}</div>
                                                                <div><b>Latest Log: </b>{this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].MostRecentLog}</div>
                                                            </div>
                                                            <div style={{ padding: 5, paddingLeft: 15, backgroundColor: "#666666", color: "#cccccc", overflowY: "auto", maxHeight: 600 }}>
                                                                <pre>{this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.slice(-1)[0].LogText}</pre>
                                                            </div>
                                                        </div>
                                                    }
                                                </ToolTip>
                                            </div>
                                        }
                                    </TableRowColumn>
                                    <TableRowColumn style={{ width: 40, cursor: "pointer", textAlign: "right" }} className="prevent-cell-click">
                                        <div onClick={e => e.stopPropagation()}>
                                            {this.state.payrollExportScheduledJob.Enabled &&
                                                permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ExportPayroll) &&
                                                < i
                                                    data-intercom-target={"PayrollExportScheduledJobTable-Btn-RunSchecduledJob"}
                                                    className="fa fa-play"
                                                    style={{ color: green500, fontSize: 20, fontWeight: "bold", cursor: "pointer" }}
                                                    onClick={() => {
                                                        AppStateStore.setConfirmDialogContent({
                                                            content: strings.formatString(strings.Are_you_sure_you_want_to_run_scheduled_job, this.state.payrollExportScheduledJob.Name) as string,
                                                            confirm: () => this.runScript(this.state.payrollExportScheduledJob)
                                                        })
                                                    }}
                                                />
                                            }
                                            {(isGlobalAdmin || this.props.isAccountManager) &&
                                                <i
                                                    data-intercom-target={"ScheduledJobsTable-Btn-OpenAddScheduledJobDialog"}
                                                    className="fa fa-pencil"
                                                    style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                    onClick={() => {
                                                        this.setState({ selectedScheduledJob: this.state.payrollExportScheduledJob, openAddScheduledJobDialog: true })
                                                    }}
                                                />
                                            }
                                            <a id="downloadAnchorElem" style={{ "display": "none" }} />
                                            {(isGlobalAdmin || this.props.isAccountManager) &&
                                                (this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs.length > 0) &&
                                                <i className="fa fa-download"
                                                    data-intercom-target={"ScheduledJobsTable-Btn-Download"}
                                                    style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                    onClick={() => {
                                                        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs));
                                                        var dlAnchorElem = document.getElementById("downloadAnchorElem");
                                                        dlAnchorElem.setAttribute("href", dataStr);
                                                        dlAnchorElem.setAttribute("download", `${this.state.payrollExportScheduledJob.Name}-${moment(this.state.payrollExportScheduledJob.CurrentScript.ScriptLogs["ScriptRunEndTime"]).format("MM/DD/YYYY hh:mma").replace(" ", "-")}.json`);
                                                        dlAnchorElem.click();
                                                    }} />
                                            }
                                            {(isGlobalAdmin || this.props.isAccountManager) &&
                                                <i
                                                    data-intercom-target={"ScheduledJobsTable-Btn-DeleteScheduledJob"}
                                                    className="fa fa-trash-o"
                                                    style={{ fontSize: 20, fontWeight: "bold", marginLeft: 15, cursor: "pointer" }}
                                                    onClick={() =>
                                                        AppStateStore.setConfirmDialogContent({
                                                            content: strings.formatString(strings.Are_you_sure_you_want_to_delete_scheduled_job, this.state.payrollExportScheduledJob.Name) as string,
                                                            confirm: () => this.delete(this.state.payrollExportScheduledJob)
                                                        })
                                                    }
                                                />
                                            }
                                        </div>
                                    </TableRowColumn>
                                </TableRow>
                            </TableBody>
                        </Table>
                }
                {this.state.openAddScheduledJobDialog &&
                    <AddScheduleJobDialog
                        hideAllowClientViewingToggle
                        hideSystemToggle
                        hideCron
                        type={EScheduledJobType.PayrollTimeExport}
                        editScheduledJob={this.state.selectedScheduledJob}
                        handleClose={() => this.setState({ openAddScheduledJobDialog: false })}
                        handleAdd={scheduledJob => this.add(scheduledJob)}
                        handleUpdate={scheduledJob => this.update(scheduledJob)}
                    />
                }
            </div>
        )
    }
}